// nvm user 8.0.0


import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import {Router, Route, Switch} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {createStore, compose, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import {createLogger} from 'redux-logger';
import {routerMiddleware, connectRouter, ConnectedRouter} from 'connected-react-router';

import { TransitionGroup, CSSTransition } from 'react-transition-group'

// ----------------------------------
// Dependancies
// ----------------------------------

import rootReducer from './Reducers';
import Home from './Components/Home'
import Resume from './Components/Resume'
import Oops from './Components/Oops'
import Contact from './Components/Contact'
import Portfolio from './Components/Portfolio'
import PortfolioItem from './Components/PortfolioItem'

// ----------------------------------
// Styles
// ----------------------------------

import './scss/base.scss'

// ----------------------------------
// Create Redux Store
// ----------------------------------

const history = createBrowserHistory();
const store = createStore(
    connectRouter(history)(rootReducer),
    compose(
        applyMiddleware(
            routerMiddleware(history),
            promise(),
            thunk,
            createLogger()
        )
    )
);

// ----------------------------------
// Render Application
// ----------------------------------

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div className="App">
              <Route render={({ location }) => (
                <TransitionGroup>
                  <CSSTransition key={location.key} classNames="transition" timeout={2000}>
                    <Switch location={location}>
                        <Route path="/" exact component={Home}  />
                        <Route path="/resume" component={Resume}  />
                        <Route path="/portfolio" exact component={Portfolio} />
                        <Route path="/portfolio/:item" component={PortfolioItem} />
                        <Route path="/contact" component={Contact} />
                        <Route path="/*" component={Oops}  />
                    </Switch>
                  </CSSTransition>
                </TransitionGroup>
              )} />

            </div>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js